import { CandidateAuditHistoryStatus, HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '../../models';
import { SYSTEM_ENUM_ROOT } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Candidate Audit History Status|`;

type SharedKeys = Pick<
	LocDef,
	'type' | 'displayType' | 'htmlAllowed' | 'portal' | 'shared' | 'feature'
>;

const sharedLocData: Pick<LocDef, 'displayType' | 'htmlAllowed' | 'shared' | 'feature'> = {
	displayType: 'System',
	htmlAllowed: false,
	shared: true,
	feature: HubFeature.OtherRequirementUploadCandidateAccessAudits,
};

const sharedSpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'SP',
};

const sharedCpLocData: SharedKeys = {
	...sharedLocData,
	portal: 'CP',
};

export type SPCandidateAuditHistoryStatusLocs =
	| `SPCandidateAuditHistoryStatusEnumClosed`
	| `SPCandidateAuditHistoryStatusEnumInQueue`
	| `SPCandidateAuditHistoryStatusEnumNew`
	| `SPCandidateAuditHistoryStatusEnumOnHold`
	| `SPCandidateAuditHistoryStatusEnumPastDue`;

export const spCandidateAuditHistoryStatusEnumLocs: LocDefs<SPCandidateAuditHistoryStatusLocs> = {
	SPCandidateAuditHistoryStatusEnumClosed: {
		defaultValue: 'Closed',
		displayPath: `${dpRoot}${CandidateAuditHistoryStatus.Closed}`,
		description: `Candidate audit history status: Closed`,
		...sharedSpLocData,
	},
	SPCandidateAuditHistoryStatusEnumInQueue: {
		defaultValue: 'In Queue',
		displayPath: `${dpRoot}${CandidateAuditHistoryStatus.InQueue}`,
		description: `Candidate audit history status: InQueue`,
		...sharedSpLocData,
	},
	SPCandidateAuditHistoryStatusEnumNew: {
		defaultValue: 'New',
		displayPath: `${dpRoot}${CandidateAuditHistoryStatus.New}`,
		description: `Candidate audit history status: New`,
		...sharedSpLocData,
	},
	SPCandidateAuditHistoryStatusEnumOnHold: {
		defaultValue: 'On Hold',
		displayPath: `${dpRoot}${CandidateAuditHistoryStatus.OnHold}`,
		description: `Candidate audit history status: OnHold`,
		...sharedSpLocData,
	},
	SPCandidateAuditHistoryStatusEnumPastDue: {
		defaultValue: 'Past Due',
		displayPath: `${dpRoot}${CandidateAuditHistoryStatus.PastDue}`,
		description: `Candidate audit history status: PastDue`,
		...sharedSpLocData,
	},
};

export type CPCandidateAuditHistoryStatusLocs =
	| `CPCandidateAuditHistoryStatusEnumClosed`
	| `CPCandidateAuditHistoryStatusEnumInQueue`
	| `CPCandidateAuditHistoryStatusEnumNew`
	| `CPCandidateAuditHistoryStatusEnumOnHold`
	| `CPCandidateAuditHistoryStatusEnumPastDue`;

export const cpCandidateAuditHistoryStatusEnumLocs: LocDefs<CPCandidateAuditHistoryStatusLocs> = {
	CPCandidateAuditHistoryStatusEnumClosed: {
		defaultValue: 'Closed',
		displayPath: `${dpRoot}${CandidateAuditHistoryStatus.Closed}`,
		description: `Candidate audit history status: Closed`,
		...sharedCpLocData,
	},
	CPCandidateAuditHistoryStatusEnumInQueue: {
		defaultValue: 'In Queue',
		displayPath: `${dpRoot}${CandidateAuditHistoryStatus.InQueue}`,
		description: `Candidate audit history status: InQueue`,
		...sharedCpLocData,
	},
	CPCandidateAuditHistoryStatusEnumNew: {
		defaultValue: 'New',
		displayPath: `${dpRoot}${CandidateAuditHistoryStatus.New}`,
		description: `Candidate audit history status: New`,
		...sharedCpLocData,
	},
	CPCandidateAuditHistoryStatusEnumOnHold: {
		defaultValue: 'On Hold',
		displayPath: `${dpRoot}${CandidateAuditHistoryStatus.OnHold}`,
		description: `Candidate audit history status: OnHold`,
		...sharedCpLocData,
	},
	CPCandidateAuditHistoryStatusEnumPastDue: {
		defaultValue: 'Past Due',
		displayPath: `${dpRoot}${CandidateAuditHistoryStatus.PastDue}`,
		description: `Candidate audit history status: PastDue`,
		...sharedCpLocData,
	},
};

export type SPCandidateAuditHistoryStatusEnumLocType = LocMap<SPCandidateAuditHistoryStatusLocs>;
export type CPCandidateAuditHistoryStatusEnumLocType = LocMap<CPCandidateAuditHistoryStatusLocs>;

export const spCandidateAuditHistoryStatusKeys: {
	[key in CandidateAuditHistoryStatus]: keyof SPCandidateAuditHistoryStatusEnumLocType;
} = {
	[CandidateAuditHistoryStatus.Closed]: 'SPCandidateAuditHistoryStatusEnumClosed',
	[CandidateAuditHistoryStatus.InQueue]: 'SPCandidateAuditHistoryStatusEnumInQueue',
	[CandidateAuditHistoryStatus.New]: 'SPCandidateAuditHistoryStatusEnumNew',
	[CandidateAuditHistoryStatus.OnHold]: 'SPCandidateAuditHistoryStatusEnumOnHold',
	[CandidateAuditHistoryStatus.PastDue]: 'SPCandidateAuditHistoryStatusEnumPastDue',
};

export const cpCandidateAuditHistoryStatusKeys: {
	[key in CandidateAuditHistoryStatus]: keyof CPCandidateAuditHistoryStatusEnumLocType;
} = {
	[CandidateAuditHistoryStatus.Closed]: 'CPCandidateAuditHistoryStatusEnumClosed',
	[CandidateAuditHistoryStatus.InQueue]: 'CPCandidateAuditHistoryStatusEnumInQueue',
	[CandidateAuditHistoryStatus.New]: 'CPCandidateAuditHistoryStatusEnumNew',
	[CandidateAuditHistoryStatus.OnHold]: 'CPCandidateAuditHistoryStatusEnumOnHold',
	[CandidateAuditHistoryStatus.PastDue]: 'CPCandidateAuditHistoryStatusEnumPastDue',
};
